import { useEffect } from "react";
import { Game } from "@tumbodash/clientGameEngine";
import usePartyStore from "../../../stores/party.js";

interface StageProps {
	setViewResults: (v: boolean) => void;
}

function Stage({ setViewResults }: StageProps) {
	const party = usePartyStore.getState().party!;
	const sessionId = party.rounds[party.activeRoundId].sessionId;

	useEffect(() => {
		setViewResults(true);
	}, []);

	useEffect(() => {
		// The lifecycle machine absorbs StrictMode remounts (release schedules a
		// deferred teardown; the re-acquire cancels it) — naive cleanup is safe.
		Game.acquire({ sessionId, mountPoint: "game-root" });
		return () => {
			Game.release(sessionId);
		};
	}, []);

	return null;
}

export default Stage;
